import { createContext, useContext, useState, type ReactNode } from "react"

const STORAGE_KEY = "offseason-admin-read-only"

interface ReadOnlyContextValue {
  readOnly: boolean
  toggleReadOnly: () => void
}

const ReadOnlyContext = createContext<ReadOnlyContextValue>({
  readOnly: false,
  toggleReadOnly: () => {},
})

export function ReadOnlyProvider({ children }: { children: ReactNode }) {
  const [readOnly, setReadOnly] = useState(() => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === "true"
    } catch {
      return false
    }
  })

  function toggleReadOnly() {
    setReadOnly((prev) => {
      const next = !prev
      try {
        sessionStorage.setItem(STORAGE_KEY, String(next))
      } catch {
        // sessionStorage unavailable
      }
      return next
    })
  }

  return (
    <ReadOnlyContext.Provider value={{ readOnly, toggleReadOnly }}>
      {children}
    </ReadOnlyContext.Provider>
  )
}

export function useReadOnly(): ReadOnlyContextValue {
  return useContext(ReadOnlyContext)
}
